import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { medicationConfig, MedicationConfigResponse } from 'services';

export type State = ApiState<MedicationConfigResponse, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchMedicationConfig = createAsyncThunk('get/medicationConfig', async () => await medicationConfig());

export const initialState = {
  isLoading: false,
  hasLoaded: false,
  data: {},
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const medicationConfigSlice = createSlice({
  name: 'medicationConfig',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMedicationConfig.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchMedicationConfig.fulfilled, (state, action: PayloadAction<MedicationConfigResponse>) => {
      state.isLoading = false;
      state.data = action.payload;
      state.hasLoaded = true;
    });

    builder.addCase(fetchMedicationConfig.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const stateSelector_ = (state: { medicationConfig: State }): State => state.medicationConfig;

export const medicationConfig_ = createSelector(stateSelector_, (state) => state.data);

export default medicationConfigSlice.reducer;
